import React from 'react';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Image from 'mui-image';

function OutOfState() {
  return (
      <div>
          <div>We are only serving Michigan at this time.</div>
          <Box display="flex"
              justifyContent="center"
              alignItems="center"
              noValidate
              marginTop="30px"
              autoComplete="off">
              <Image src="images/Michigan.png" width={100} height={100} />
          </Box>
      </div>
  );
}

export default OutOfState;